export const SuspenseLoader = () => (
  <div
    className="flex size-full flex-row items-center justify-center"
    data-testid="suspense-loader"
  >
    <div className="border-darkest size-4 animate-spin rounded-full border-b-2" />
  </div>
);
